//
// Copyright (c) 2011-2018 by Curalate, Inc.
//
import { PojoMap } from 'pojo-maps';
import { PojoSet } from 'pojo-sets';

import { GalleriesAddToGalleriesModalActionType } from '@galleries/actions/galleriesAddToGalleriesModalActions';
import { GALLERIES_ACTIONS } from '@galleries/constants/galleriesConstants';
import { IGalleriesAddToGalleriesModal } from '@galleries/models/galleriesStateModel';
import { IRightsRequestState } from '@models/IItemMetadata';
import PartialCuid from '@models/PartialCuid';

export const initialState: IGalleriesAddToGalleriesModal = {
  isOpen: false,
  initiallySelectedItems: [],
  gallerySelection: {},
  isBazaarvoiceSyndicationSelected: true,
  materializedItems: [],
  currentlySelectedItems: {},
  isLoading: false,
  rightsRequestStates: PojoMap.empty<PartialCuid, IRightsRequestState>(),
};

export default function GalleriesAddToGalleriesModalReducer(
  state: IGalleriesAddToGalleriesModal = initialState,
  action: GalleriesAddToGalleriesModalActionType,
): IGalleriesAddToGalleriesModal {
  switch (action.type) {
    case GALLERIES_ACTIONS.OPEN_ADD_TO_GALLERIES_MODAL: {
      return {
        ...state,
        isOpen: true,
        initiallySelectedItems: action.items,
        gallerySelection: {},
      };
    }
    case GALLERIES_ACTIONS.CLOSE_ADD_TO_GALLERIES_MODAL: {
      return {
        ...state,
        isOpen: false,
        isBazaarvoiceSyndicationSelected: true,
        initiallySelectedItems: [],
        gallerySelection: {},
      };
    }
    case GALLERIES_ACTIONS.ADD_MODAL_SET_SELECTED_GALLERIES: {
      return {
        ...state,
        gallerySelection: PojoSet.from(action.reelIds),
      };
    }
    case GALLERIES_ACTIONS.ADD_MODAL_SELECT_GALLERY: {
      return {
        ...state,
        gallerySelection: PojoSet.add(state.gallerySelection, action.reelId),
      };
    }
    case GALLERIES_ACTIONS.ADD_MODAL_DESELECT_GALLERY: {
      return {
        ...state,
        gallerySelection: PojoSet.remove(state.gallerySelection, action.reelId),
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_MATERIALIZED_ITEMS: {
      return {
        ...state,
        materializedItems: action.materializedItems,
      };
    }
    case GALLERIES_ACTIONS.SELECT_IMAGE: {
      return {
        ...state,
        currentlySelectedItems: {
          ...state.currentlySelectedItems,
          [action.selectedItem.id]: action.selectedItem,
        },
      };
    }
    case GALLERIES_ACTIONS.DESELECT_IMAGE: {
      const newSelectedImages = { ...state.currentlySelectedItems };

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete newSelectedImages[action.deselectedItem.id];

      return {
        ...state,
        currentlySelectedItems: newSelectedImages,
      };
    }
    case GALLERIES_ACTIONS.CLEAR_IMAGES: {
      return {
        ...state,
        currentlySelectedItems: {},
      };
    }
    case GALLERIES_ACTIONS.CLEAR_MATERIALIZED_ITEMS: {
      return {
        ...state,
        materializedItems: [],
      };
    }
    case GALLERIES_ACTIONS.IS_LOADING: {
      return {
        ...state,
        isLoading: action.isLoading,
      };
    }
    case GALLERIES_ACTIONS.RECEIVE_RIGHTS_REQUEST_STATES: {
      return {
        ...state,
        rightsRequestStates: action.rightsRequestMap,
      };
    }
    case GALLERIES_ACTIONS.TOGGLE_BAZAAR_VOICE_SYNDICATION: {
      return {
        ...state,
        isBazaarvoiceSyndicationSelected:
          !state.isBazaarvoiceSyndicationSelected,
      };
    }
    default:
      return state;
  }
}
